<template>
  <div v-if="value.meta">
    <el-divider />
    <h3>Additional Details</h3>
    <el-row :gutter="60">
      <el-col :span="24" :md="12" class="">
        <el-input-title required>Your Classification</el-input-title>
        <el-form-item prop="meta.classification">
          <el-input disabled v-model="value.meta.classification" placeholder="Your classification"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>
<script>

export default {
  name: 'dsaExtra',
  props: ['value'],
  data() {
    return {};
  },
  mounted() {

  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
